import { useCallback, useEffect, useState } from 'react';
import { getEventBus } from '@alfa-bank/newclick-core/window-utils';
import { endedVoipScreens, voipScreens } from '../constants/types';
import { useVoipContext } from './use-voip-context';
import { useWebview } from './use-webview';
import { useWidgetContext } from './use-widget-context';
const eventBus = getEventBus();
export const useHistoryBasedNavigation = () => {
    const { voipScreen, setVoipScreen } = useVoipContext();
    const { canOpenedPopup, openedPopup, setOpenedPopup } = useWidgetContext();
    const { bridgeToNative } = useWebview();
    const isCloseable = voipScreen !== voipScreens.WITH_CALL;
    const [isReservePage, setIsReservePage] = useState(false);
    const handleHistoryPush = useCallback(() => {
        const { pathname, search } = window.location;
        // корректируем историю переходов - добавляем запись, не меняя текущий адрес
        bridgeToNative?.nativeNavigationAndTitle.handleRedirect(`${pathname}${search}`, {
            isReservePage: true,
        });
        setIsReservePage(true);
    }, [bridgeToNative]);
    const historyPopListener = useCallback(() => {
        setIsReservePage(false);
        if (!isCloseable && canOpenedPopup) {
            setOpenedPopup(true);
            return;
        }
        if (endedVoipScreens.includes(voipScreen)) {
            setVoipScreen(voipScreens.WITHOUT_CALL);
        }
    }, [canOpenedPopup, isCloseable, setOpenedPopup, setVoipScreen, voipScreen]);
    useEffect(() => {
        if (!isCloseable && !isReservePage) {
            // если текущий шаг не должен закрываться при переходе назад
            handleHistoryPush();
        }
    }, [handleHistoryPush, isCloseable, isReservePage]);
    useEffect(() => {
        if (isCloseable && openedPopup) {
            setOpenedPopup(false);
        }
    }, [isCloseable, openedPopup, setOpenedPopup]);
    useEffect(() => {
        eventBus?.subscribe('HISTORY_POP', historyPopListener);
        return () => {
            eventBus?.unsubscribe('HISTORY_POP', historyPopListener);
        };
    }, [historyPopListener]);
    return null;
};
